import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { getNextCrimeTime, makeCrime } from "@/helper/contractFunctions/MafiaBasicCrime";
import { getCrimeType } from "@/helper/contractFunctions/MafiaJail";

export interface CrimeState {
  isMakingCrime: boolean;
  nextCrimeTime: number;
  myCrimeType: number;
}

const initialState: CrimeState = {
  isMakingCrime: false,
  nextCrimeTime: -1,
  myCrimeType: 0,
};

export const makeCrimeAction = createAsyncThunk(
  "crime/makeCrimeAction",
  async ({ crimeType, account }: { crimeType: number; account: string }) =>
    makeCrime(crimeType, account)
);

export const getNextCrimeTimeAction = createAsyncThunk(
  "crime/getNextCrimeTimeAction",
  getNextCrimeTime
);

export const getCrimeTypeAction = createAsyncThunk(
  "crime/getCrimeTypeAction",
  getCrimeType
);

const crimeSlice = createSlice({
  name: "crime",
  initialState,
  reducers: {
    finishCrime: (state) => {
      state.isMakingCrime = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(makeCrimeAction.pending, (state) => {
        state.isMakingCrime = true;
      })
      .addCase(makeCrimeAction.rejected, (state) => {
        state.isMakingCrime = false;
      })
      .addCase(getNextCrimeTimeAction.fulfilled, (state, { payload }) => {
        state.nextCrimeTime = payload;
      })
      .addCase(getNextCrimeTimeAction.rejected, (state) => {
        state.nextCrimeTime = -1;
      })
      .addCase(getCrimeTypeAction.fulfilled, (state, { payload }) => {
        state.myCrimeType = payload;
      });
  },
});

export const { finishCrime } = crimeSlice.actions;
export default crimeSlice.reducer;
